import { graphql } from "@opensea/graphql"
import { ProfileHeaderMetadataChipsFragment } from "./ProfileHeaderMetadataChips.fragment"
import { ProfileInfoFragment } from "./ProfileInfo.fragment"

export const ProfileHeaderCompactContentFragment = graphql(
  `
    fragment ProfileHeaderCompactContent on Profile {
      address
      ...ProfileInfo
      ...ProfileHeaderMetadataChips
    }
  `,
  [ProfileInfoFragment, ProfileHeaderMetadataChipsFragment],
)
